import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterOptions', pure: false })
export class FilterOptionsPipe implements PipeTransform {
    constructor() {}

    transform(items: any, text: string): any {
        if (!items || !items.length || !text) {
            return items;
        }

        return items.filter((item: any) => {
            return (
                (item.label || '').toLowerCase().indexOf(text.toLowerCase()) >
                -1
            );
        });
    }
}
